import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { DevicesPage } from '@/features/admin/devices/device-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

type DevicesSearch = { page?: number; online?: boolean };

/**
 * Appareils en périphérie du tenant. Page courante (`?page=`, la première ne l'écrit pas) et filtre
 * de présence (`?online=true|false`, absent = tous) vivent dans l'URL. Changer de filtre revient à
 * la première page.
 */
export const Route = createFileRoute('/$tenant/resources/devices/')({
  validateSearch: (search: Record<string, unknown>): DevicesSearch => {
    const page = Number(search['page']);
    const online = search['online'];
    return {
      ...(Number.isInteger(page) && page > 0 ? { page } : {}),
      ...(online === true || online === 'true' ? { online: true } : {}),
      ...(online === false || online === 'false' ? { online: false } : {}),
    };
  },
  component: DevicesRoute,
});

function DevicesRoute() {
  const { tenant } = Route.useParams();
  const { page = 0, online } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="devices" crumbs={[{ label: t('nav.items.devices') }]}>
      <DevicesPage
        tenantId={tenant}
        page={page}
        online={online}
        onPageChange={(next) =>
          void navigate({
            search: { ...(next > 0 ? { page: next } : {}), ...(online === undefined ? {} : { online }) },
            replace: true,
          })
        }
        onOnlineChange={(next) =>
          void navigate({ search: next === undefined ? {} : { online: next }, replace: true })
        }
      />
    </ConsoleShell>
  );
}
